export default __webpack_public_path__ + "static/media/app-store.b58bdff6.svg";